import { SenderDetails } from "../types/common";
import { Box, Typography } from "@mui/material";

type Props = {
  senderDetails: SenderDetails;
  renderIcon: () => JSX.Element | null;
};

const InboxRowSecondaryText = ({ senderDetails, renderIcon }: Props) => {
  if (senderDetails?.topic && senderDetails.details) {
    return <>{senderDetails.details}</>;
  }

  return (
    <>
      {senderDetails.topic ? (
        <Box
          display="flex"
          alignItems="center"
          gap="6px"
          minWidth={0}
          overflow="hidden"
        >
          <Typography
            variant="body1"
            color="text.primary"
            fontSize="16px"
            fontWeight={600}
            noWrap
            sx={{ flex: "0 1 auto", minWidth: 0, lineHeight: "20px" }}
          >
            {senderDetails.topic}
          </Typography>
          {senderDetails.icon && (
            <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
              {renderIcon()}
            </Box>
          )}
        </Box>
      ) : (
        senderDetails.details
      )}
    </>
  );
};

export default InboxRowSecondaryText;
